module.exports = __webpack_public_path__ + "img/太阳.0b1cb954.png";